import {Component, OnInit, ViewChild} from '@angular/core';
import {PartenaireService} from '../../../shared/services/partenaire.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PartnerDtoModel} from '../../../shared/models/partner.dto.model';
import {LoaderService} from '../../../shared/services/loader.service';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {LocalizationService} from '../../../shared/services/localization.service';
import {TagService} from '../../../shared/services/tag.service';
import {CategoryService} from '../../../shared/services/category.service';
import {CategoryDtoModel} from '../../../shared/models/category.dto.model';
import {TagDtoModel} from '../../../shared/models/tag.dto.model';
import {FileUpload} from 'primeng/fileupload';
import {FileService} from '../../../shared/services/file.service';
import {CountryService} from '../../../shared/services/country.service';
import {CountryDtoModel} from '../../../shared/models/country.dto.model';
import {PreferencesServices} from '../../../shared/services/preferences.services';
import {PreferenceDtoModel} from '../../../shared/models/preference.dto.model';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'njoy-detail-partenaire',
    templateUrl: './detail-partenaire.component.html',
    styleUrls: ['./detail-partenaire.component.scss']
})
export class DetailPartenaireComponent implements OnInit {

    public partnerUuid: string;
    public partner = new PartnerDtoModel();
    public partnerForm;
    public matcher = new ErrorStateMatcher();

    public allCategories = [];
    public categories = [];
    public remaingCategory = [];
    public selectedCategory;
    public tags = [];
    public countries = [];

    public clickToUpdateTitle = 'cliquer pour modifier';

    @ViewChild(FileUpload)
    private fileUploader: FileUpload;
    public addressNotFound = false;
    public oldPartnerIdExists = false;

    public allPreferences = [];
    public mainPreferences = [];
    public secondaryPreferences = [];
    public remainingText = 2000;

    public isDraft = false;

    public isEmojiPickerVisible = false

    public emojiPickerLabels = {
        search: this.localizationService.translate('EMOJI_PICKER.SEARCH'),
        emojilist: this.localizationService.translate('EMOJI_PICKER.LIST'),
        notfound: this.localizationService.translate('EMOJI_PICKER.NOT_FOUND'),
        clear: this.localizationService.translate('EMOJI_PICKER.CLEAR'),
        categories: {
            search: this.localizationService.translate('EMOJI_PICKER.CATEGORY_SEARCH'),
            recent: this.localizationService.translate('EMOJI_PICKER.CATEGORY_RECENT'),
            people: this.localizationService.translate('EMOJI_PICKER.CATEGORY_PEOPLE'),
            nature: this.localizationService.translate('EMOJI_PICKER.CATEGORY_NATURE'),
            foods: this.localizationService.translate('EMOJI_PICKER.CATEGORY_FOODS'),
            activity: this.localizationService.translate('EMOJI_PICKER.CATEGORY_ACTIVITY'),
            places: this.localizationService.translate('EMOJI_PICKER.CATEGORY_PLACES'),
            objects: this.localizationService.translate('EMOJI_PICKER.CATEGORY_OBJECTS'),
            symbols: this.localizationService.translate('EMOJI_PICKER.CATEGORY_SYMBOLS'),
            flags: this.localizationService.translate('EMOJI_PICKER.CATEGORY_FLAGS'),
            custom: this.localizationService.translate('EMOJI_PICKER.CATEGORY_CUSTOM')
        },
        skintones: {
            1: 'Default Skin Tone',
            2: 'Light Skin Tone',
            3: 'Medium-Light Skin Tone',
            4: 'Medium Skin Tone',
            5: 'Medium-Dark Skin Tone',
            6: 'Dark Skin Tone',
        }
    }

    public displayEmoji = true;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private partenaireService: PartenaireService,
                private preferencesService: PreferencesServices,
                private countryService: CountryService,
                private fileService: FileService,
                private tagService: TagService,
                private categoryService: CategoryService,
                private loaderService: LoaderService,
                public localizationService: LocalizationService,
                private messageService: MessageService,
                private confirmationService: ConfirmationService,
                private formBuilder: UntypedFormBuilder,
                public sanitizer: DomSanitizer) {

    }

    ngOnInit(): void {
        this.initEmptyForm();
        this.fetchPreferencesValues();
    }

    public setRemainingCharsValue(): void {
        this.remainingText = 2000 - this.getControl.description.value.length;
    }

    private fetchPreferencesValues() {
        this.preferencesService.findAllPreferences().subscribe((prefs: PreferenceDtoModel[]) => {
            prefs.forEach((pref: PreferenceDtoModel) => {
                this.allPreferences.push({
                    value: pref.label,
                    displayedValue: this.localizationService.translate('PREFRENCES.' + pref.label)
                });
            });
            this.mainPreferences = [...this.allPreferences];
            this.secondaryPreferences = [...this.allPreferences];
            this.partnerUuid = this.route.snapshot.paramMap.get('partnerUuid');
            if (this.partnerUuid === '0') {
                this.getListCategories();
            } else {
                this.getPartnerByUuid();
            }
        });
    }

    private initEmptyForm() {
        this.partnerForm = this.formBuilder.group({
            name: ['', [
                Validators.required
            ]],
            username: [{value: '', disabled: true}],
            uuid: [{value: '', disabled: true}],
            website: [''],
            phoneNumber: [''],
            description: ['', [Validators.required,
                Validators.maxLength(2000)]],
            streetAddress: ['', [
                Validators.required
            ]],
            city: ['', [
                Validators.required
            ]],
            zipCode: ['', [
                Validators.required
            ]],
            country: ['', [
                Validators.required
            ]],
            mainCategory: [this.allCategories[0], [
                Validators.required
            ]],
            secondaryCategory: [[]],
            tag: [''],
            heartstroke: [false],
            popular: [false],
            keywords: [[]],
            mainPreferences: [[]],
            secondaryPreferences: [[]],
            oldId: ['', [Validators.min(1), Validators.pattern('^[1-9]\\d*$')]],
            emoji: ['&#128512;']
        });
    }

    get getControl() {
        return this.partnerForm.controls;
    }

    private getPartnerByUuid(): void {
        this.loaderService.startLoading();
        this.partenaireService.getPartnerByUuid(this.partnerUuid).subscribe(
            (data: PartnerDtoModel) => {
                this.partner = data;
                this.isDraft = this.partner.draft;
                this.getListCategories();
            }, (err: any) => {
                this.loaderService.stopLoading();
                console.log('error while getting partner..');
                console.log(err);
            }
        )
    }

    private setValues(): void {
        this.partnerForm = this.formBuilder.group({
            name: [this.partner.name, [
                Validators.required
            ]],
            username: [{value: this.partner.userName, disabled: true}],
            uuid: [{value: this.partner.uuid, disabled: true}],
            website: [this.partner.websiteLink],
            phoneNumber: [this.partner.phoneNumber],
            description: [this.partner.description, [Validators.required,
                Validators.maxLength(2000)]],
            streetAddress: [this.partner.address.streetAddress, [
                Validators.required
            ]],
            city: [this.partner.address.city, [
                Validators.required
            ]],
            zipCode: [this.partner.address.zipCode, [
                Validators.required
            ]],
            country: [this.partner.address.countryUuid, [
                Validators.required
            ]],
            mainCategory: [this.allCategories.find(value => value.value.uuid === this.partner.mainCategory.uuid), [
                Validators.required
            ]],
            secondaryCategory: [this.getPersistedCategories()],
            tag: [this.partner.tagUuid ?? null],
            heartstroke: [this.partner.heartStroke],
            popular: [this.partner.popular],
            keywords: [this.partner.keywords],
            oldId: [this.partner.oldId, [Validators.min(1), Validators.pattern('^[1-9]\\d*$')]],
            // Avec optionValue="value", le formulaire attend les labels (strings)
            mainPreferences: [(this.partner.preferences || []).filter((p: string) => p != null && p !== '')],
            secondaryPreferences: [(this.partner.secondaryPreferences || []).filter((p: string) => p != null && p !== '')],
            emoji: ['&#' + this.partner.emoji + ';']
        });
        this.setRemainingCharsValue();
        this.initCategoriesList();
        this.initPreferencesList();
    }

    private initCategoriesList(): void {
        this.setRemainingCategories({value: {value: this.partner.mainCategory}}, true);
        this.setRemainingCategories({value: null}, false);
    }

    private initPreferencesList(): void {
        this.setRemainingTags(true);
        this.setRemainingTags(false);
    }


    public updatePartner(): void {
        this.addressNotFound = false;
        this.oldPartnerIdExists = false;
        if (this.partnerForm.status === 'VALID' && this.partner.imagePath && this.partner.imagePath !== '') {
            this.loaderService.startLoading();
            this.patchValues();
            if (this.partnerUuid === '0') {
                this.callAddPartnerWS();
            } else {
                this.callUpdatePartnerWS();
            }
        } else {
            if (this.partnerForm.status !== 'VALID') {
                this.displayToastMessage('error', 'PARTNER.VALIDATION_ERROR', 'PARTNER.REQUIRED_FIELDS_NOT_COMPLETED');
            } else {
                this.displayToastMessage('error', 'PARTNER.VALIDATION_ERROR', 'PARTNER.IMAGE_NOT_UPLOADED');
            }
        }
    }

    private patchValues(): void {
        this.partner.name = this.partnerForm.value.name;
        this.partner.websiteLink = this.partnerForm.value.website;
        this.partner.phoneNumber = this.partnerForm.value.phoneNumber;
        this.partner.description = this.partnerForm.value.description;
        this.partner.heartStroke = this.partnerForm.value.heartstroke;
        this.partner.popular = this.partnerForm.value.popular;
        this.partner.secondaryCategoriesUuids = this.partnerForm.value.secondaryCategory.map(value => value.value.uuid);
        this.partner.mainCategorieUuid = this.partnerForm.value.mainCategory.value.uuid;
        this.partner.address.streetAddress = this.partnerForm.value.streetAddress;
        this.partner.address.city = this.partnerForm.value.city;
        this.partner.address.zipCode = this.partnerForm.value.zipCode;
        this.partner.address.countryUuid = this.partnerForm.value.country;
        const tagValue = this.partnerForm.value.tag;
        this.partner.tagUuid = (Array.isArray(tagValue) ? tagValue[0] : tagValue) ?? null;
        this.partner.keywords = this.partnerForm.value.keywords;
        // Avec optionValue="value", le formulaire stocke les labels (strings) ; on filtre tout null/undefined
        const toPreferenceLabel = (v: any): string | null =>
            v == null ? null : (typeof v === 'string' ? v : (v.value != null ? v.value : null));
        this.partner.preferences = (this.partnerForm.value.mainPreferences || [])
            .map(toPreferenceLabel)
            .filter((v): v is string => v != null && v !== '');
        this.partner.secondaryPreferences = (this.partnerForm.value.secondaryPreferences || [])
            .map(toPreferenceLabel)
            .filter((v): v is string => v != null && v !== '');
        this.partner.oldId = this.partnerForm.value.oldId;
        this.partner.emoji = this.getControl.emoji.value.substring(2, this.getControl.emoji.value.length - 1);
    }

    private displayToastMessage(severity: string, summary: string, detail: string): void {
        this.messageService.add({
            severity: severity,
            summary: this.localizationService.translate(summary),
            detail: this.localizationService.translate(detail)
        });
    }

    private getListCategories(): void {
        this.loaderService.startLoading();
        this.categoryService.findAllCategories().subscribe((data: CategoryDtoModel[]) => {
                data.forEach((category: CategoryDtoModel) => {
                    this.allCategories.push({
                        value: category,
                        displayedValue: category.label
                    });
                });
                this.remaingCategory = [...this.allCategories];
                this.categories = [...this.allCategories];
                this.getListTags();
            }, ((error: any) => {
                this.loaderService.stopLoading();
                console.log(error);
            })
        );
    }

    private getListTags(): void {
        this.loaderService.startLoading();
        this.tags = [];
        this.tagService.findAllTagsDTO().subscribe(
            (data: TagDtoModel[]) => {
                this.tags.push({
                    label: 'Aucun',
                    uuid: null
                });
                data.forEach((item: TagDtoModel) => {
                    this.tags.push(item);
                });
                this.getListCountries();
            }, (err: any) => {
                this.loaderService.stopLoading();
                console.log(err);
            });
    }

    public openFileUploader(): void {
        this.fileUploader.basicFileInput.nativeElement.click();
    }

    public uploadImage(): void {
        const file = this.fileUploader.files[0];
        this.loaderService.startLoading();
        if (this.partnerUuid === '0') {
            this.uploadFileAndSetPath(file);
        } else {
            this.uploadFileAndUpdatePartner(file);
        }
    }


    private uploadFileAndUpdatePartner(file: File): void {
        this.fileService.uploadAndUpdatePartnerFile(file, this.partnerUuid).subscribe(
            (path: string) => {
                this.fileUploader.clear();
                this.loaderService.stopLoading();
                this.partner.imagePath = path;
            }, (err: any) => {
                this.fileUploader.clear();
                this.loaderService.stopLoading();
                console.log(err)
            }
        );
    }

    private uploadFileAndSetPath(file: File): void {
        this.fileService.uploadPartnerFile(file).subscribe(
            (path: string) => {
                this.fileUploader.clear();
                this.loaderService.stopLoading();
                this.partner.imagePath = path;
            }, (err: any) => {
                this.loaderService.stopLoading();
                console.log(err)
            }
        );
    }

    private getListCountries(): void {
        this.countryService.findAllCountries().subscribe((data: CountryDtoModel[]) => {
            this.loaderService.stopLoading();
            this.countries = data;
            this.countries.sort((one, two) => (one.libelleFR > two.libelleFR ? 1 : -1));
            if (this.partnerUuid !== '0') {
                this.setValues();
            } else {
                this.initEmptyForm();
                this.setRemainingCategories({value: this.categories[0]}, true)
            }
        }, (err: any) => {
            this.loaderService.stopLoading();
            console.log(err);
        });
    }

    private getPersistedPreferences(preferences: string[]): any[] {
        const tab = [];
        if (preferences) {
            this.allPreferences.forEach((val: any) => {
                preferences.forEach((pref: any) => {
                    if (val.value === pref) {
                        tab.push(val);
                    }
                })
            });
        }

        return tab;
    }

    private getPersistedCategories(): any[] {
        const tab = [];
        this.categories.forEach((val: any) => {
            this.partner.secondaryCategories.forEach((category: any) => {
                if (val.value.uuid === category.uuid) {
                    tab.push(val);
                }
            })
        });

        return tab;
    }


    public confirmChangeDraftStatus(): void {
        this.confirmationService.confirm({
            message: !this.isDraft ? this.localizationService.translate('PARTNER.DRAFT_CONFIRMATION_MESSAGE') : this.localizationService.translate('PARTNER.PUBLISH_CONFIRMATION_MESSAGE') + this.partner.name,
            key: 'brouillonCd',
            accept: () => {
                this.publishOrDraftPartner();
            }
        });
    }

    public publishOrDraftPartner(): void {
        this.isDraft = !this.isDraft;
        this.partner.draft = !this.partner.draft;
        this.updatePartner();
    }

    public setRemainingCategories(event: any, mainCategory: boolean): void {
        if (mainCategory) {
            this.remaingCategory = [...this.allCategories];
            const index = this.remaingCategory.findIndex(value => value.value.uuid === event.value.value.uuid);
            if (index !== -1) {
                this.remaingCategory.splice(index, 1);
            }
        } else {
            this.categories = [...this.allCategories];
            const selectedUuids = this.partnerForm.value.secondaryCategory.map(value => value.value.uuid);
            selectedUuids.forEach(uuid => {
                const index = this.categories.findIndex(value => value.value.uuid === uuid);
                if (index !== -1) {
                    this.categories.splice(index, 1);
                }
            });
        }
    }

    private callUpdatePartnerWS(): void {
        this.partenaireService.updatePartner(this.partner).subscribe(
            () => {
                this.loaderService.stopLoading();
                this.displayToastMessage('success', 'CLIENT.SUCCESS_SUMMARY', 'PARTNER.UPDATE_SUCCESS_DETAIL');
            }, (err: any) => {
                this.loaderService.stopLoading();
                console.log('error while updating client..');
                console.log(err);
                if (err.error.code === 4031) {
                    this.addressNotFound = true;
                }
                if (err.error.code === 4033) {
                    this.oldPartnerIdExists = true;
                }
            });
    }

    private callAddPartnerWS(): void {
        this.partenaireService.addNewPartner(this.partner).subscribe(
            (uuid: any) => {
                this.partner.uuid = uuid;
                this.partnerUuid = uuid;
                this.loaderService.stopLoading();
                this.displayToastMessage('success', 'CLIENT.SUCCESS_SUMMARY', 'PARTNER.ADD_SUCCESS_DETAIL');
                this.router.navigate(['/partners', uuid]);
            }, (err: any) => {
                this.loaderService.stopLoading();
                console.log('error while adding partner..');
                console.log(err);
                if (err.error.code === 4031) {
                    this.addressNotFound = true;
                }
                if (err.error.code === 4033) {
                    this.oldPartnerIdExists = true;
                }
            });
    }

    public setRemainingTags(updateMaintags: boolean): void {
        const toLabel = (v: any) => (typeof v === 'object' && v != null ? v.value : v);
        if (updateMaintags) {
            this.mainPreferences = [...this.allPreferences];
            const selectedSecondary = (this.partnerForm.value.secondaryPreferences || [])
                .filter((v: any) => v != null)
                .map(toLabel);
            selectedSecondary.forEach(selectedPref => {
                const index = this.mainPreferences.findIndex((p: any) => p.value === selectedPref);
                if (index !== -1) {
                    this.mainPreferences.splice(index, 1);
                }
            });
        } else {
            this.secondaryPreferences = [...this.allPreferences];
            const selectedMain = (this.partnerForm.value.mainPreferences || [])
                .filter((v: any) => v != null)
                .map(toLabel);
            selectedMain.forEach(selectedPref => {
                const index = this.secondaryPreferences.findIndex((p: any) => p.value === selectedPref);
                if (index !== -1) {
                    this.secondaryPreferences.splice(index, 1);
                }
            });
        }
    }

    public addEmoji(event: any) {
        this.getControl.emoji.value = '&#' + parseInt(event.emoji.unified, 16) + ';';
        this.isEmojiPickerVisible = false;
        this.displayEmoji = true;
    }

    public openEmojiPicker() {
        this.displayEmoji = false;
        this.isEmojiPickerVisible = !this.isEmojiPickerVisible;
    }

    public validatePhoneNumber(event: any): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        // Only Numbers 0-9
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    }

}
